import {get, post} from '@/utils/request'

const api = {
  // 公共分类
  common: {
    
  },
  // 登录绑定
  login: {
    bindPhone: (payload) => post('/open/bindPhone', payload), // 首次登录 -绑定手机号
    setComplete: (payload) => post('/open/setComplete', payload), // 首次登录-填写基本信息
    logout: (payload) => post('/open/logout', payload), // 退出登录

    // 获取公共信息
    getYear: (payload) => get('/city/get_year', payload), // 获取高考年份
    getProvince: (payload) => get('/city/getProvince', payload), // 获取省份
    getCity: (payload) => post('/city/getCity', payload), // 获取城市
    getSubject: (payload) => post('/city/get_subject', payload), // 获取选科
    checkCompletes: (payload) => post('/user/checkCompletes', payload), // 资料完整验证
  },
  // 首页
  home: {
    getHotRecommend: (payload) => post('/video/getHotRecommend', payload), // 热门推荐
    getTestQuestions: (payload) => post('/video/getTestQuestions', payload), // 最新题库
  },
  // 知识点精讲
  knowledge: {
    lists: (payload) => post('/knowledge/lists', payload), // 列表分类
    view: (payload) => post('/knowledge/view', payload), // 知识点内容
  },
  // 题库
  exam: {
    list: (payload) => post('/exam/lists', payload), // 题库列表
    download: (payload) => post('/exam/down', payload), // 下载题库
  },
  // 升学课堂
  video: {
    getList: (payload) => post('/video/getList', payload), // 课程列表
    getView: (payload) => post('/video/view', payload), // 播放页
    add: (payload) => post('/follow/add', payload), // 关注视频
    del: (payload) => post('/follow/del', payload), // 取消关注
  },
  // 个人中心
  usercenter: {
    profile: (payload) => post('/user_center/profile', payload), // 个人资料
    setProfile: (payload) => post('/user_center/setProfile', payload), // 设置个人资料
    myVideo: (payload) => post('/user_center/myVideo', payload), // 观看记录
    collectionVideo: (payload) => post('/user_center/collectionVideo', payload), // 我的收藏
    resetPassword: (payload) => post('/user_center/resetPassword', payload), // 重置密码
    information: (payload) => post('/user_center/userInformationVerification', payload), // 验证用户基础信息
    changePhone: (payload) => post('/user_center/changePhone', payload), // 换绑手机
  }
}

export default {
  install (Vue) {
    Vue.prototype.$api = api
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js